/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Default_Preview_TextInputs */



/**
* | output |
* | --- |
* | "John walks into the bar to see Alice already waiting for him. She sips her drink nervously." |
*
* @param {Voice_Manager_Default_Preview_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_default_preview_text = /** @type {((inputs?: Voice_Manager_Default_Preview_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Default_Preview_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("John walks into the bar to see Alice already waiting for him. She sips her drink nervously.")
	if (locale === "de") return /** @type {LocalizedString} */ ("John betritt die Bar und sieht Alice bereits auf ihn warten. Sie nippt nervös an ihrem Getränk.")
	if (locale === "it") return /** @type {LocalizedString} */ ("John entra nel bar e trova Alice che lo sta già aspettando. Sorseggia nervosamente il suo drink.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Джон заходит в бар и видит, что его уже ждет Элис. Она нервно отпивает свой напиток.")
	if (locale === "es") return /** @type {LocalizedString} */ ("John entra al bar y ve a Alice ya esperándolo. Ella bebe su bebida con nerviosismo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("约翰走进酒吧，看到爱丽丝已经在等他了。她紧张地抿了一口酒。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョンがバーに入ると、アリスがすでに待っていた。彼女は緊張しながら飲み物を一口飲む。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जॉन बार में दाखिल होता है तो देखता है कि ऐलिस पहले से ही उसका इंतजार कर रही है। वह घबराकर अपनी ड्रिंक की चुस्की लेती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("John entra no bar e vê Alice já à sua espera. Ela toma um gole da sua bebida, nervosa.")
	return /** @type {LocalizedString} */ ("John walks into the bar to see Alice already waiting for him. She sips her drink nervously.")
});